<template>
    <span>
        {{ $date(timestamp).to($date(this.now)) }}
    </span>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["timestamp"],
    computed: {
        ...mapState("system", ["now"]),
    },
};
</script>
